import { BaseNetworkActionValidator } from '../base.network.action.validator';
import { ProtectedEntity } from '@nirvana/shared/dtos/types/protected-entities/common';
import { ProtectedEntitiesHelper } from '../../../helpers/protectedEntities/protected.entities.helper';

export class UninstallAgentActionValidator extends BaseNetworkActionValidator {
  protected canRunForUnmanagedCompanies = false;
  protected requiresTasksEnabled = true;

  protected _canPerformAction(record: ProtectedEntity): boolean {
    if (!ProtectedEntitiesHelper.isComputer(record)) {
      return true;
    }

    const isSva: boolean = !!record.specifics.isSva;
    const isGhostr: boolean = !!record.specifics.isGhostr;
    const isSandboxAnalyzer: boolean = !!record.specifics.isSandboxAnalyzer;
    const isNsva: boolean = !!record.specifics.isNsva;

    if (isSva || isGhostr || isSandboxAnalyzer || isNsva) {
      return false;
    }

    if (record.isProtectedBySecurityContainer) {
      return false;
    }

    if (ProtectedEntitiesHelper.isComputer(record)) {
      return !!record.specifics.isManaged;
    }

    if (record.specifics.serverHasNsxIntegration) {
      return ProtectedEntitiesHelper.isUnifiedClient(record);
    }

    return true;
  }
}
